const suspenseLoadingCircle = 'suspenseLoadingCircle';

export default suspenseLoadingCircle;
